var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    width: 102,
    height: 102,
    transform: "translate(1604 4136)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_hospital",
    transform: "translate(-1604 -4136)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(1627.617 4143.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6221",
    "data-name": "Path 6221",
    d: "M58.138,2.252H51.493a1.334,1.334,0,1,0,0,2.668h.824V78.571H2.523V4.919H8.074v3.03a4.216,4.216,0,0,0,4.212,4.212h6.306a7.474,7.474,0,0,0,7.342,6.128h2.972a7.474,7.474,0,0,0,7.341-6.128h6.306a4.217,4.217,0,0,0,4.213-4.212V2.193a4.217,4.217,0,0,0-4.213-4.212H12.286A4.217,4.217,0,0,0,8.074,2.193v.059H-3.3A5.326,5.326,0,0,0-8.618,7.571V61.115a1.333,1.333,0,0,0,1.334,1.334A1.334,1.334,0,0,0-5.95,61.115V7.571A2.656,2.656,0,0,1-3.3,4.919H-.145V79.9a1.334,1.334,0,0,0,1.334,1.334H53.651A1.333,1.333,0,0,0,54.985,79.9V4.919h3.153a2.655,2.655,0,0,1,2.652,2.652V83.717a2.655,2.655,0,0,1-2.652,2.653H-3.3A2.656,2.656,0,0,1-5.95,83.717V67.4a1.335,1.335,0,0,0-1.334-1.334A1.334,1.334,0,0,0-8.618,67.4V83.717A5.326,5.326,0,0,0-3.3,89.037H58.138a5.325,5.325,0,0,0,5.319-5.32V7.571a5.325,5.325,0,0,0-5.319-5.319Zm-47.4-.059A1.546,1.546,0,0,1,12.286.648H42.553A1.546,1.546,0,0,1,44.1,2.193V7.949a1.546,1.546,0,0,1-1.544,1.544h-7.52A1.334,1.334,0,0,0,33.7,10.827a4.8,4.8,0,0,1-4.794,4.794H25.934a4.8,4.8,0,0,1-4.794-4.794,1.334,1.334,0,0,0-1.334-1.334h-7.52a1.546,1.546,0,0,1-1.544-1.544Zm0,0",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6222",
    "data-name": "Path 6222",
    d: "M220.924,266.818h-7.053l-4.508-12.309a1.335,1.335,0,0,0-2.545.13L201.977,273.7,197.3,260.1a1.335,1.335,0,0,0-2.425-.219l-3.889,6.932h-4.046a1.334,1.334,0,1,0,0,2.668h4.827a1.335,1.335,0,0,0,1.164-.681l2.813-5.017,5.16,15.01a1.335,1.335,0,0,0,2.554-.105l4.881-19.215,3.344,9.133a1.333,1.333,0,0,0,1.253.875h7.984a1.334,1.334,0,0,0,0-2.668Zm0,0",
    transform: "translate(-176.514 -232.341)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6223",
    "data-name": "Path 6223",
    d: "M220.924,639.355H186.943a1.334,1.334,0,0,0,0,2.668h33.981a1.334,1.334,0,0,0,0-2.668Zm0,0",
    transform: "translate(-176.513 -582.882)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6224",
    "data-name": "Path 6224",
    d: "M220.924,768.207H186.943a1.334,1.334,0,0,0,0,2.668h33.981a1.334,1.334,0,0,0,0-2.668Zm0,0",
    transform: "translate(-176.513 -699.983)",
    fill: "#f9556d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs5);
export default __webpack_public_path__ + "static/media/ss5.e83434079937b240867c346d4f7956e2.svg";
export { ForwardRef as ReactComponent };